import api from "./Api";

class FiscalSpedFiscalService {
  GetJobsOData(payload) {
    return api
      .get("/v1/fiscal/sped/fiscal/jobs" + payload)
      .then((response) => response.data);
  }

  PostJob(payload) {
    return api
      .post("/v1/fiscal/sped/fiscal/jobs", payload)
      .then((response) => response.data);
  }

  DeleteJob(payload) {
    return api
      .delete("/v1/fiscal/sped/fiscal/jobs/" + payload)
      .then((response) => response.data);
  }

  DownloadJob(payload) {
    return api
      .get("/v1/fiscal/sped/fiscal/jobs/" + payload + "/download", {
        responseType: "blob",
      })
      .then((response) => response);
  }

  GetFiltros() {
    return api
      .get("/v1/fiscal/sped/fiscal/filtros")
      .then((response) => response.data);
  }

  GetConfiguracoes() {
    return api
      .get("/v1/fiscal/sped/fiscal/configuracoes")
      .then((response) => response.data);
  }

  PutConfiguracoes(payload) {
    return api
      .put("/v1/fiscal/sped/fiscal/configuracoes", payload)
      .then((response) => response.data);
  }

  GetBlocoKEstoques() {
    return api
      .get("/v1/fiscal/sped/fiscal/bloco-k/estoques")
      .then((response) => response.data);
  }

  GetBlocoKEstoque(id) {
    return api
      .get(`/v1/fiscal/sped/fiscal/bloco-k/estoques/${id}`)
      .then((response) => response.data);
  }

  ProcessarBlocoKEstoque(payload) {
    return api
      .post("/v1/fiscal/sped/fiscal/bloco-k/processar", payload)
      .then((response) => response.data);
  }

  PostBlocoKEstoque(payload) {
    return api
      .post("/v1/fiscal/sped/fiscal/bloco-k/estoques", payload)
      .then((response) => response.data);
  }
}

export default new FiscalSpedFiscalService();
